/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useState, useEffect, useImperativeHandle } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { exportResourceBarrierPFD, getResourceBarrierPFD } from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { IBarrierStatusSpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import { IResourceBarrierPFDReport } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    dictionaryStatusMap: Map<number, IBarrierStatusSpecialStatus>
    setExportLoading: (k: boolean) => void
}

interface IOrder {
    field: string
    order: boolean
}

export const ResourceBarrierPFDs = React.forwardRef<any, IProps>(function ResourceBarrierPFDs(
    {
        setItemsLength,
        numberOfItems,
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        setPage,
        dictionaryStatusMap,
        setExportLoading
    },
    ref
) {
    // const [list] = useState(new Map<number, IBarrierStatus[]>())
    const [events, setEvents] = useState<IResourceBarrierPFDReport>()
    const [isLoading, setIsLoading] = useState(false)

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchBarrierId, setSearchBarrierId] = useState<string>('')
    const [listBarrierId, setListBarrierId] = useState(new Set<string>())
    const [filterBarrierId, setFilterBarrierId] = useState(new Set<string>())

    const [searchBarrierName, setSearchBarrierName] = useState<string>('')
    const [listBarrierName, setListBarrierName] = useState(new Set<string>())
    const [filterBarrierName, setFilterBarrierName] = useState(new Set<string>())

    const [searchInitialPFD, setSearchInitialPFD] = useState<string>('')
    const [listInitialPFD, setListInitialPFD] = useState(new Set<string>())
    const [filterInitialPFD, setFilterInitialPFD] = useState(new Set<string>())

    const [searchFinalPFD, setSearchFinalPFD] = useState<string>('')
    const [listFinalPFD, setListFinalPFD] = useState(new Set<string>())
    const [filterFinalPFD, setFilterFinalPFD] = useState(new Set<string>())

    const [searchThreshold, setSearchThreshold] = useState<string>('')
    const [listThreshold, setListThreshold] = useState(new Set<string>())
    const [filterThreshold, setFilterThreshold] = useState(new Set<string>())

    const [searchStatus, setSearchStatus] = useState<string>('')
    const [listStatus, setListStatus] = useState(new Set<string>())
    const [filterStatus, setFilterStatus] = useState(new Set<string>())

    const [searchDate, setSearchDate] = useState<string>('')
    const [listDate, setListDate] = useState(new Set<string>())
    const [filterDate, setFilterDate] = useState(new Set<string>())

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const [update, setUpdate] = useState<number>(0)

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const converted = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${converted}`
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr key={index} className={`resource-barrier-pfd ${index === 0 ? 'first-margin' : ''}`}>
                        <td valign="middle" className={'common-width'}>
                            {item.resource}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.bowtieCode}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierId}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierName}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.initialPfd}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span>{item.finalPfd}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span>{item.threshold}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span className={`barrierStatus ${item.status}`} style={{ color: item.statusColor }}>
                                {item.status}
                            </span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {dateConverter(item.date)}
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const convertDateToTs = (dateToTs: Set<string>): string[] => {
        const arr = []
        dateToTs.forEach(item => {
            const dateFormating = new Date(item).getTime()
            arr.push(dateFormating)
        })

        return arr
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const barrierPFDEvents = await getResourceBarrierPFD({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: formatSetToArray(filterResource),
                filterByBowtieCode: formatSetToArray(filterBowtieCode),
                filterByBarrierId: formatSetToArray(filterBarrierId),
                filterByBarrierName: formatSetToArray(filterBarrierName),
                filterByInitialPfd: formatSetToArray(filterInitialPFD),
                filterByFinalPfd: formatSetToArray(filterFinalPFD),
                filterByThreshold: formatSetToArray(filterThreshold),
                filterByStatus: formatSetToArray(filterStatus),
                filterByDate: convertDateToTs(filterDate)
            })
            setEvents(barrierPFDEvents)
            setItemsLength(barrierPFDEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useImperativeHandle(ref, () => ({
        async exportResourceBarrierPFD() {
            try {
                setExportLoading(true)
                await exportResourceBarrierPFD({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: formatSetToArray(filterResource),
                    filterByBowtieCode: formatSetToArray(filterBowtieCode),
                    filterByBarrierId: formatSetToArray(filterBarrierId),
                    filterByBarrierName: formatSetToArray(filterBarrierName),
                    filterByInitialPfd: formatSetToArray(filterInitialPFD),
                    filterByFinalPfd: formatSetToArray(filterFinalPFD),
                    filterByThreshold: formatSetToArray(filterThreshold),
                    filterByStatus: formatSetToArray(filterStatus),
                    filterByDate: convertDateToTs(filterDate)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterInitialPFD,
        filterFinalPFD,
        filterThreshold,
        filterStatus,
        filterDate
    ])

    useEffect(() => {
        setPage(1)
    }, [
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterInitialPFD,
        filterFinalPFD,
        filterThreshold,
        filterStatus,
        filterDate
    ])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainer customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className={'resource-barrier-pfd-header'}>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierId}
                                    setSearch={setSearchBarrierId}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.ID}
                                    list={listBarrierId}
                                    setList={setListBarrierId}
                                    filter={filterBarrierId}
                                    setFilter={setFilterBarrierId}
                                    onClearAll={update}
                                    buttonTitle="barrier id"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierName}
                                    setSearch={setSearchBarrierName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_NAME}
                                    list={listBarrierName}
                                    setList={setListBarrierName}
                                    filter={filterBarrierName}
                                    setFilter={setFilterBarrierName}
                                    onClearAll={update}
                                    buttonTitle="barrier name"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchInitialPFD}
                                    setSearch={setSearchInitialPFD}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.INITIAL_PFD}
                                    list={listInitialPFD}
                                    setList={setListInitialPFD}
                                    filter={filterInitialPFD}
                                    setFilter={setFilterInitialPFD}
                                    onClearAll={update}
                                    buttonTitle="initial pfd"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchFinalPFD}
                                    setSearch={setSearchFinalPFD}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.FINAL_PFD}
                                    list={listFinalPFD}
                                    setList={setListFinalPFD}
                                    filter={filterFinalPFD}
                                    setFilter={setFilterFinalPFD}
                                    onClearAll={update}
                                    buttonTitle="final pfd"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchThreshold}
                                    setSearch={setSearchThreshold}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.THRESHOLD}
                                    list={listThreshold}
                                    setList={setListThreshold}
                                    filter={filterThreshold}
                                    setFilter={setFilterThreshold}
                                    onClearAll={update}
                                    buttonTitle="threshold"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchStatus}
                                    setSearch={setSearchStatus}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.STATUS}
                                    list={listStatus}
                                    setList={setListStatus}
                                    filter={filterStatus}
                                    setFilter={setFilterStatus}
                                    onClearAll={update}
                                    buttonTitle="status"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchDate}
                                    setSearch={setSearchDate}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.DATE}
                                    list={listDate}
                                    setList={setListDate}
                                    filter={filterDate}
                                    setFilter={setFilterDate}
                                    onClearAll={update}
                                    buttonTitle="date/time"
                                    last
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
})
